import { useState } from "react";
import { Share2, Link2, Check, MessageCircle, Mail } from "lucide-react";
import { toast } from "sonner";
import { eventShareUrl } from "@/data/eventTypes";
import { formatDate } from "@/lib/api";

export const partageTexte = (e) => `${e.titre} — ${e.date_label || formatDate(e.date)} · Entre Les Mondes`;
export const whatsappHref = (e) => `https://wa.me/?text=${encodeURIComponent(`${partageTexte(e)}\n${eventShareUrl(e)}`)}`;

export const copierLien = async (e) => {
  try {
    await navigator.clipboard.writeText(eventShareUrl(e));
    toast.success("Lien copié — avec aperçu (titre et image) sur WhatsApp et Facebook");
    return true;
  } catch {
    toast.error("Impossible de copier — sélectionnez le lien manuellement");
    return false;
  }
};

export const EventShare = ({ event, tone = "light" }) => {
  const [copie, setCopie] = useState(false);
  const cls = tone === "dark"
    ? "inline-flex items-center gap-2 px-4 py-2 rounded-full border border-sand/25 text-sand/85 text-xs hover:bg-sand/10 transition-colors duration-300"
    : "inline-flex items-center gap-2 px-4 py-2 rounded-full border border-wood/25 text-bark text-xs hover:border-terra hover:text-terra transition-colors duration-300";
  const copier = async () => { if (await copierLien(event)) { setCopie(true); setTimeout(() => setCopie(false), 2000); } };
  const natif = async () => {
    try { await navigator.share({ title: event.titre, text: partageTexte(event), url: eventShareUrl(event) }); } catch { /* fermé */ }
  };
  return (
    <div className="flex flex-wrap items-center gap-2" data-testid="event-share">
      <span className={`font-mono text-[10px] uppercase tracking-[0.25em] mr-1 ${tone === "dark" ? "text-sand/60" : "text-fumee"}`}>Partager</span>
      <a href={whatsappHref(event)} target="_blank" rel="noopener noreferrer" className={cls} data-testid="event-share-whatsapp"><MessageCircle className="w-3.5 h-3.5" /> WhatsApp</a>
      <a href={`mailto:?subject=${encodeURIComponent(event.titre)}&body=${encodeURIComponent(`${partageTexte(event)}\n${eventShareUrl(event)}`)}`} className={cls} data-testid="event-share-email"><Mail className="w-3.5 h-3.5" /> E-mail</a>
      <button type="button" onClick={copier} className={cls} title="Lien avec aperçu (titre et image) — ouvre la fiche" data-testid="event-share-copy">{copie ? <Check className="w-3.5 h-3.5" /> : <Link2 className="w-3.5 h-3.5" />} {copie ? "Copié" : "Copier le lien"}</button>
      {typeof navigator !== "undefined" && navigator.share && <button type="button" onClick={natif} className={cls} data-testid="event-share-native"><Share2 className="w-3.5 h-3.5" /> Plus</button>}
    </div>
  );
};
